import { type RouteRecordRaw } from 'vue-router';
import { handleCnameRedirect } from '@/utils';

const Links = () => import('@/pages/links/index.vue');
const PersonalLink = () => import('@/pages/personal-link/PersonalLink.vue');
const ReceiptPage = () => import('@/pages/receipt/index.vue');

const hasLinkPrefix = (): boolean => window.location.pathname.startsWith('/link');

const handleRoutes = (): RouteRecordRaw[] => {
  const routes: RouteRecordRaw[] = [];

  const prefix = hasLinkPrefix() ? '/link' : '';

  routes.push(
    {
      name: 'links',
      path: `${prefix}/:id(\\d+)`,
      component: Links,
    },
    {
      name: 'personalLink',
      path: `${prefix}/:id([a-zA-Z0-9@.]+.*)`,
      component: PersonalLink,
    },
    {
      name: 'receipt',
      path: `${prefix}/receipt/:id`,
      component: ReceiptPage,
      props: true,
    },
    {
      name: 'personalLinkRoot',
      path: `${prefix}/`,
      component: PersonalLink,
      beforeEnter: (_to, _from, next) => {
        handleCnameRedirect(prefix);
        next();
      },
    }
  );

  return routes;
};

export default handleRoutes;
